

































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Resource from "../Resource.vue";
import Engine, { Faction, Player, Resource as ResourceEnum } from "@gaia-project/engine";
import PowerBowl from "./PowerBowl.vue";
import { showIncome } from "../../data/resources";

@Component<PowerBowls>({
  components: {
    Resource,
    PowerBowl,
  },
})
export default class PowerBowls extends Vue {
  @Prop()
  player: Player;

  get engine(): Engine {
    return this.$store.state.data;
  }

  get showIncome() {
    return showIncome(this.engine, this.player);
  }

  get isTerran() {
    return this.player.faction === Faction.Terrans;
  }

  get r() {
    return 2;
  }

  get spacing() {
    return 1.1;
  }

  get sin60() {
    return 0.86602540378;
  }

  income(resource: ResourceEnum) {
    return this.player.resourceIncome(resource);
  }
}
